import { registerSW } from "virtual:pwa-register";

/**
 * Registers the service worker with the failure path handled.
 *
 * `vite-plugin-pwa`'s default `injectRegister: "auto"` injects a one-liner into
 * `index.html` that calls `navigator.serviceWorker.register()` and ignores the
 * promise it returns:
 *
 *     navigator.serviceWorker.register('/sw.js', { scope: '/' })
 *
 * When registration is refused — blocked site data, a private window, an
 * enterprise policy, security software — that promise rejects with nothing
 * attached to it, and the rejection surfaces as an unhandled error (Sentry saw
 * "Error: Rejected" from `/registerSW.js`). Registering from here instead, with
 * `injectRegister: null` in `vite.config.ts`, gives the rejection somewhere to
 * land.
 *
 * The service worker is a progressive enhancement — it only pre-caches static
 * assets (see the `workbox` config) — so a browser that refuses it still gets a
 * fully working app. That makes this a warning, not something to report.
 */
export function registerServiceWorker(): void {
  registerSW({
    immediate: true,
    onRegisterError(error: unknown) {
      console.warn("[pwa] Service worker registration failed; continuing without offline caching.", error);
    },
  });
}
